/**
 * @description 公用js
 * @author 
 */
import $ from 'jquery'
import util from "../js/util.js";
import areas from "@/common/js/area.json";
import {
  Message
} from 'element-ui'
import {
  DH_UNABLE_TO_CHECK_GENERATOR
} from 'constants';
// var res = undefined;
/**
 * @description 防止异步调用接口，不能及时返回值，封装接口调用方法为同步
 * @param {axios} axios 客户端协议
 * @param {string} url 接口地址
 * @param {string} method 请求方式（get/post）
 * @param {object} params 传递参数
 */
var cusAxiosAsync = function (axios, url, method, params) {
  // res = undefined;
  if (method.toLowerCase() == 'get') {
    return axios.get(url, {
      params: params
    });
  } else {
    return axios.post(url, params);
  }

}
/**
 * @description 转化为金额格式
 */
function format_money(num, row, index) {
  //判断预处理数据不为空或0才进行处理
  if (num != null && num != undefined && Number(num) != 0) {
    // 将数的小数部分和整数部分分开操作 将整数部分进行三位一逗号的操作 
    var k = "";
    if (num < 0) {
      var k = "-";
    }
    var arr = parseFloat(Math.abs(num)).toFixed(2).toString().split('.');
    var l = arr[0];
    var r = arr[1];
    // 将整数部分胡成字符串形式并进行反转
    l = l.split('').reverse().join('');
    // 利用正则进行三位添加一逗号的操作 注意在插入逗号的时候存在在最后一位插入逗号的可能
    l = l.replace(/(\d{3})/g, function (m, m1) {
      return m1 + ',';
    });
    l = l.split('').reverse().join('');
    // 将字符串反转回去 有可能第一位就是一个逗号 若出现这种现象 舍去首位的逗号
    if (l[0] == ',') {
      l = l.slice(1);
    }
    // 将处理后的整数部分加上小数部分返回
    if (num < 0) {
      return '<span class="danger">' + k + l + '.' + r + '</span>';
    } else
      return l + '.' + r;
  } else
    return '-';
}

let imgUrl = function () {
  return Glod.UrlPrefix
}

export default {
  imgUrl: '',
  /**
   * @description 初始权限验证
   */
  initPage() {
    // roleValidater();localStorage.removeItem('user');
  },
  getSession(name) {
    let assess = sessionStorage.getItem(name);
    if (assess == null) {
      return null;
    }
    return JSON.parse(assess);
  },
  setSession(name, value) {
    sessionStorage.setItem(name, JSON.stringify(value))
  },
  removeSession(name) {
    sessionStorage.removeItem(name);
  },
  /**
   * @description 获取用户信息
   * @return {object} 用户对象
   */
  getUser: function () {
    var obj = sessionStorage.getItem('user');
    if (obj) {
      return JSON.parse(obj);
    } else {
      return {};
    }
  },
  getUser2: function () {
    var obj = sessionStorage.getItem('userInfo');
    if (obj) {
      return JSON.parse(obj);
    } else {
      return {};
    }
  },
  getMessageCount: function () {
    var obj = sessionStorage.getItem('messagecount');
    if (obj) {
      return JSON.parse(obj);
    } else {
      return undefined;
    }
  },
  /**
   * @description 用户是否是管理员
   * @return {Boolean}
   */
  isAdmin: function () {
    let user = this.getUser();
    if (user.accuntType == 1 || user.userId == -1) {
      return true;
    } else {
      return false;
    }
  },
  /**
   * @description 获取单个附件信息
   * @param {axios} axios 客户端协议
   * @param {string} keyCode 附件keyCode
   * @returns 附件信息
   */
  getSingleEnclosureUrl: function (axios, keyCode, callback) {
    cusAxiosAsync(axios, "api/COM/Common/GetSingleEnclosureUrl?kenCode=" + keyCode, 'get').then(response => {
      var res = [];
      if (response.data.result != null) {
        res = response.data.result;
      }
      // else {
      //     res = response.data.Msg;
      // }
      callback(res);
    }).catch((error) => {
      console.log(error) //请求失败返回的数据
      callback('');
    });
  },

  /**
   * @description 获取附件信息
   * @param {axios} axios 客户端协议
   * @param {string} keyCode 附件keyCode
   * @returns 附件信息
   */
  getFileList: function (axios, keyCode, callback) {
    cusAxiosAsync(axios, "api/Enclosure/GetComEnclosure?keyCode=" + keyCode, 'get').then(response => {
      var res = [];
      if (response.data.result != null) {
        res = response.data.result;
      }
      // else {
      //     res = response.data.Msg;
      // }
      callback(res);
    }).catch((error) => {
      console.log(error) //请求失败返回的数据
    });
  },
  /**
   * @description 上传文件
   */
  InsertComEnclosures() {
    axios.get(url, {
      params: params
    })
  },
  /**
   * @description 字符串转换json对象
   * @param {string}} value json格式字符串
   */
  JSONConvert(value) {
    try {
      var obj = JSON.parse(value);
      return obj;
    } catch (e) {
      console.log(e);
      return value;
    }
  },
  /**
   * @description 列表控件标题样式设置
   */
  headerStyle() {
    return 'background-color:#f2f3f5;color:#666';
  },
  rowstyle: function (row, rowIndex) {
    // console.log(row.rowIndex);
  },
  /**
   * @description 分页控件显示数据选项
   */
  cuspage() {
    return [5, 10, 20, 100, 500]
  },
  /**
   * @description 分页控件自定义显示及排序
   */
  cuspagelayout() {
    return "total, sizes, prev, pager, next, jumper"
  },
  /**
   * @description 上传文件地址(不能放在这里，需要写到全局配置里)
   */
  uploadUrl() {
    return Glod.UrlPrefix;
  },
  //附件下载
  download(name, url) {
    let link = document.createElement("a");
    //将url转成blob地址
    let params = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    };
    fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        // 将链接地址字符内容转变成blob地址
        link.href = URL.createObjectURL(blob);
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // 下载完成移除元素
      })
    //window.location.href=url;
    // let a = document.createElement('a')
    // a.href=url;
    // a.download=name;
    // a.target='_blank'
    // a.click();
  },
  /**
   * @description 获取代码信息
   * @param {axios} axios 客户端协议
   * @param {string} code 代码表唯一标识（表名）
   * @param {function} callback 执行成功后的回调函数
   */
  getCodeItem: function (axios, code, callback) {
    var params = {
      "code": code
    };
    var url = "api/Com/GetCodeItemByCode?code=" + code;
    cusAxiosAsync(axios, url, 'get', {})
      .then(response => {
        var res = [];
        if (response.data.result != null) {
          res = response.data.result;
        }
        callback(res.filter(n => {
          return n.status == true;
        }));
      }).catch((error) => {
        console.log(error)

      });
  },
  /**
   * @description 获取区域
   * @param {string} region 区域代码
   * @param {function} callback 执行成功后的回调函数
   */
  getAreas(region, callback) {
    callback(areas.filter(function (item) {
      return item.pregion == region;
    }));
  },
  /**
   * @description 获取行业信息
   * @param {axios} axios 客户端协议
   * @param {string} industryId 行业编号（整形 -1 为全部）
   * @param {function} callback 执行成功后的回调函数
   */
  getIndustry(axios, industryId, callback) {
    var params = {
      "industryId": industryId
    };
    var url = "/api/Com/GetIndustry";
    cusAxiosAsync(axios, url, 'get', params)
      .then(response => {
        var res = [];
        if (response.data.result != null) {
          res = response.data.result;
        }
        callback(res);
      }).catch((error) => {
        console.log(error)

      });
  },
  //获取验证码
  setCode(axios, phone) {
    return new Promise((resolve, reject) => {
      let url = `api/Com/SendPhoneCodeByPhone?phone=${phone}`;
      axios.post(url).then((res) => {
        if (res.data.statusCode != 200) {
          return reject(new Error(res.data.msg).message);
        } else {
          return resolve(res.data.msg);
        }
      });
    });
  },
  //验证手机号是否已被使用
  verPhone(axios, phone) {
    return new Promise((resolve, reject) => {
      let url = `api/SYS/SysAccount/PhoneIsRegistered?phone=${phone}`;
      axios.get(url).then((res) => {
        if (res.data.result) {
          return reject(new Error("手机号已使用，请更换其它手机号码").message);
        } else {
          return resolve();
        }
      }).catch((msg) => {
        // Message.warning(msg)
        return reject(new Error(msg).message);
      });

    });
  },
  //验证用户名是否已被使用
  verAccount(axios, accountName) {
    return new Promise((resolve, reject) => {
      let url = `api/SYS/SysAccount/AccountNameRegistered?accountName=${accountName}`;
      axios.post(url).then((res) => {
        if (res.data.Result) {
          return reject(new Error("用户名已使用，请更换其它用户名").message);
        } else {
          return resolve();
        }
      }).catch((msg) => {
        // Message.warning(msg)
        return reject(new Error(msg).message);
      });

    });
  },

  getStartDateTime(year) {
    var date = new Date();
    return `${date.getFullYear() - year}-${date.getMonth() + 1}-${date.getDate()} 00:00:00`;
  },
  getEndDateTime(year) {
    var date = new Date();
    return `${date.getFullYear() - year}-${date.getMonth() + 1}-${date.getDate()} 23:59:59`;
  },
  //验证验证码
  verCode(axios, phone, code) {
    return new Promise((resolve, reject) => {
      let url = `api/Com/VerificationPhoneCode?phone=${phone}&code=${code}`;
      axios.post(url).then((res) => {
        if (!res.data.result) {
          return reject(new Error("验证码错误").message);
        } else {
          return resolve();
        }
      }).catch((msg) => {
        // Message.warning(msg)
        return reject(new Error(msg).message);
      });
    });
  },
  formatDate(date, pattern) {
    return util.formatDate.format(date, pattern);
  },
  formatter(row, column, cellValue, index) {
    return util.foDate(cellValue);
  },
  foDateTime(row, column, cellValue, index) {
    return util.foDateTime(cellValue);
  },
  foDate(value) {
    return util.foDate(value);
  },
  forMoney(row, column, cellValue, index) {
    if (isNaN(parseFloat(cellValue))) {
      return 0.00;
    } else {
      return format_money(cellValue);
    }
  },
  formatMoney(value) {
    if (isNaN(parseFloat(value))) {
      return 0.00;
    } else {
      return format_money(value);
    }
  },
  formatterAddWang(row, column, cellValue, index) {
    if (isNaN(parseFloat(cellValue))) {
      return 0.00;
    } else {
      return cellValue + '万元';
    }
  },
  formatterloantimestr(row, column, cellValue, index) {
    var str = cellValue;
    var end = row.loantimeend
    if (isNaN(parseInt(str))) {
      str = "''";
    }
    if (isNaN(parseInt(end))) {
      end = "''";
    }
    return str + '-' + end + '年';

  },
  formatterloanintereststr(row, column, cellValue, index) {
    var str = cellValue;
    var end = row.loaninterestend
    if (isNaN(parseInt(str))) {
      str = "''";
    }
    if (isNaN(parseInt(end))) {
      end = "''";
    }
    return str + '%-' + end + '%每年';
  },
  formatterAddPercent(row, column, cellValue, index) {
    if (isNaN(parseFloat(cellValue))) {
      return 0.00;
    } else {
      return cellValue + '%';
    }
  },
  inputMoneyChange(e) {
    //验证输入的金额
    var self = this;
    var obj = e.target;
    //如果用户第一位输入的是小数点，则重置输入框内容
    if (obj.value != "" && obj.value.substr(0, 1) == ".") {
      obj.value = "";
    }
    obj.value = obj.value.replace(/^0*(0\.|[1-9])/, "$1"); //粘贴不生效
    obj.value = obj.value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
    obj.value = obj.value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
    obj.value = obj.value
      .replace(".", "$#$")
      .replace(/\./g, "")
      .replace("$#$", ".");
    obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
    if (obj.value.indexOf(".") < 0 && obj.value != "") {
      //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
      if (obj.value.substr(0, 1) == "0" && obj.value.length == 2) {
        obj.value = obj.value.substr(1, obj.value.length);
      }
    }
  },

  toTwoDecimal(e, callback) {
    var obj = e.target;
    if (isNaN(parseFloat(obj.value))) {
      obj.value = 0.00;
      callback(obj.value);
    } else {
      obj.value = obj.value ? ((isNaN(parseFloat(obj.value.toString().replace(/,/g, ""))) ? 1 : parseFloat(obj
        .value.toString().replace(/,/g, "")))).toFixed(2).toString() : "";
      callback(obj.value);
    }
  },
  truncationValue(val, len) {
    if (val) {
      if (val.length > len) {
        return val.substr(0, len) + "......";
      }
    }

    return val;
  },
  /**
   * 防抖函数
   * @param {Function} func  需要防抖的函数
   * @param {Number} wait  时间
   * @param {Boolean} immediate  是否立即执行
   */
  debounce(func, wait, immediate = false) {
    let timeout;
    return function () {
      let context = this;
      let args = arguments;
      if (timeout) clearTimeout(timeout);

      if (immediate) {
        let callNow = !timeout;
        timeout = setTimeout(() => {
          timeout = null;
        }, wait);

        if (callNow) {
          func.apply(context, args);
        }
      } else {
        timeout = setTimeout(() => {
          func.apply(context, args);
        }, wait);
      }
    }
  },
  isMobile() {
    let flag = window.navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
    console.log(flag)
    return flag;
  },
  isPhone(phone) {
    const reg = /^[1][3567849][0-9]{9}$/;
    if ((!reg.test(phone))) {
      return false;
    } else {
      return true;
    }
  },
}



// WEBPACK FOOTER //
// ./src/common/js/common.js